const exam = [
  {
    id: 1,
    title: 'Languages & Compilers',
    category: 'CSC',
    name: 'CSC 3300',
    img: './images/csc.png',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 2,
    title: 'Computer Architecture',
    category: 'CSC',
    name: 'CSC 3300',
    img: './images/csc.png',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 3,
    title: 'Accounting Principles 1',
    category: 'BA',
    name: 'BA 3301',
    img: './images/ba.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 4,
    title: 'Accounting Principles 2',
    category: 'BA',
    name: 'BA 3302',
    img: './images/ba.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 5,
    title: 'Works In Literature	',
    category: 'SHSS',
    name: 'SHSS 3300',
    img: './images/shss.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 6,
    title: 'Calculus 1',
    category: 'EMS',
    name: 'IMS 3300',
    img: './images/ims.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 7,
    title: 'Software Engineering',
    category: 'CSC',
    name: 'CSC 3300',
    img: './images/csc.png',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 8,
    title: 'Financial Accounting',
    category: 'BA',
    name: 'BA 3300',
    img: './images/ba.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 9,
    title: 'Linear Algebra',
    category: 'EMS',
    name: 'IMS 3300',
    img: './images/ims.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 10,
    title: 'Philosophical Thoughts',
    category: 'SHSS',
    name: 'SHSS 3300',
    img: './images/shss.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 11,
    title: 'Computer Architecture',
    category: 'CSC',
    name: 'CSC 3300',
    img: './images/csc.png',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 12,
    title: 'Accounting Principles 1',
    category: 'BA',
    name: 'BA 3300',
    img: './images/ba.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 13,
    title: 'Accounting Principles 2',
    category: 'BA',
    name: 'BA 3300',
    img: './images/ba.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 14,
    title: 'Works In Literature	',
    category: 'SHSS',
    name: 'SHSS 3300',
    img: './images/shss.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 15,
    title: 'Calculus 1',
    category: 'EMS',
    name: 'IMS 3300',
    img: './images/ims.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 16,
    title: 'Software Engineering',
    category: 'CSC',
    name: 'CSC 3300',
    img: './images/csc.png',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 17,
    title: 'Financial Accounting',
    category: 'BA',
    name: 'BA 3300',
    img: './images/ba.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
  {
    id: 18,
    title: 'Linear Algebra',
    category: 'EMS',
    name: 'IMS 3300',
    img: './images/ims.jpg',
    link: 'https://drive.google.com/file/d/1H3GIIQK1Bc9VBAj82jlHTTn20w096P9N/view',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.',
  },
]

export default exam
